export enum CustomBotEventTypes
{
  LIKE = "LIKE",
  DISLIKE = "DISLIKE",
  CLOSEHANDOFF = "CLOSEHANDOFF"
}